import React from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { Alert, Box, CircularProgress, Tab, Tabs } from '@mui/material';
import useIsAdmin from '../../hooks/useIsAdmin';
import Stats from '../Stats';
import ApiKeysView from './ApiKeysView';

// Admin-Bereich unter /admin. Jeder Reiter hat eine eigene Adresse, damit
// Lesezeichen und Zurück-Knopf funktionieren. Die Endpunkte prüfen das
// Admin-Recht selbst — hier geht es nur darum, was die Oberfläche anbietet.
const REITER = [
  { pfad: 'statistiken', label: 'Statistiken', element: <Stats /> },
  { pfad: 'api-keys', label: 'API-Schlüssel', element: <ApiKeysView /> },
];

export default function AdminView() {
  const isAdmin = useIsAdmin();
  const location = useLocation();
  const navigate = useNavigate();

  if (isAdmin === null) {
    return (
      <Box display="flex" justifyContent="center" py={6}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAdmin) {
    return (
      <Box sx={{ maxWidth: 760, mx: 'auto', p: { xs: 2, md: 4 } }}>
        <Alert severity="warning" sx={{ borderRadius: 3 }}>
          Dieser Bereich ist nur für Admins freigeschaltet.
        </Alert>
      </Box>
    );
  }

  const aktiv = REITER.find((r) => location.pathname.startsWith(`/admin/${r.pfad}`));

  return (
    <>
      <Box sx={{ maxWidth: 1120, mx: 'auto', px: { xs: 2, md: 4 }, pt: { xs: 2, md: 3 } }}>
        <Tabs
          value={aktiv ? aktiv.pfad : false}
          onChange={(_e, pfad) => navigate(`/admin/${pfad}`)}
          variant="scrollable"
          allowScrollButtonsMobile
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          {REITER.map((r) => (
            <Tab key={r.pfad} value={r.pfad} label={r.label} />
          ))}
        </Tabs>
      </Box>
      <Routes>
        {REITER.map((r) => (
          <Route key={r.pfad} path={r.pfad} element={r.element} />
        ))}
        <Route path="*" element={<Navigate to="statistiken" replace />} />
      </Routes>
    </>
  );
}
